import { basicColorsNameMap } from '../__internal__/BasicColorPallete';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-ColorPicker-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
/**
 * Hook to get color name corresponding to the standard color's hex value.
 * Only the names of Standard colors can be retrieved, for anything other than the standard colors null will be returned.
 * @param props
 * @param props.colorHexCode hex code of the standard color
 * @param props.isLocalized flag to determine whether localized colorname should be returned.
 * @returns color name string or null in case of non-standard colors.
 */
export const useStandardColorName = props => {
  const localize = useTextLocalizer();
  const {
    colorHexCode,
    isLocalized
  } = props;
  const colorValue = basicColorsNameMap[colorHexCode];
  if (isLocalized) {
    // return localized color name
    return colorValue ? localize(`color.${colorHexCode.slice(1)}.title`) : null;
  } else {
    // return color name in english
    return colorValue ? colorValue : null;
  }
};
//# sourceMappingURL=useStandardColorName.js.map